import { Component, Input } from '@angular/core';
import {
    LoadingController,
    NavController,
    NavParams
} from 'ionic-angular';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/mergeMap';
import { ApiService } from '../../../../services/api';
import { Rodeo } from '../../../../model/rodeo';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { ReportsService } from '../../../../services/reports.service';
import { Account } from '../../../../model/account';
import { EntryCostGenerator } from '../../../../lib/entryCostGenerator';
import { Horse } from '../../../../model/horse';
import { RodeoEventRun } from '../../../../model/rodeoEventRun';

@Component({
    selector: 'page-alpha-report',
    templateUrl: 'report-alpha.html'

})
export class AlphaReport {
    @Input('rodeo') rodeo: Rodeo;

    options: any[] = [];
    searchChangeObservable;

    documentTitle: any;
    popoverActive: boolean;
    dataLoaded: boolean;
    printing: boolean;
    searchName: string;

    rodeoEventMap: any[];
    sidepotMap: any[];
    exhibitionMap: any[];
    
    showContactInfo: boolean = false;
    showMembershipStatus: boolean = false;

    entryCostGenerator: EntryCostGenerator = EntryCostGenerator.instance();
    selectedRodeoEvent: any = 'All';

    constructor(private nav: NavController, navParams: NavParams, public api: ApiService, public reportService: ReportsService, private loadingControl: LoadingController) {
        if (!this.rodeo)
            this.rodeo = navParams.get('rodeo');

        this.printing = navParams.get('printing');
        this.options = navParams.get('options');

        if (!this.options)
            this.options = [];
        else
            this.updateOptions();
        
        this.searchName = navParams.get('searchName');

        this.selectedRodeoEvent = navParams.get('selectedRodeoEvent');

        if (!this.selectedRodeoEvent || !this.selectedRodeoEvent.id) {
            this.selectedRodeoEvent = 'All';
        }

        if (this.printing) {
            setTimeout(() => {
                this.load();
            }, 0);
        }
    }

    load() {
        this.rodeoEventMap = [];
        this.sidepotMap = [];
        this.exhibitionMap = [];

        this.rodeo.rodeoEvents.forEach((rodeoEvent) => {
            this.rodeoEventMap[rodeoEvent.id] = rodeoEvent;

            rodeoEvent.sidepots.forEach((sidepot) => {
                this.sidepotMap[sidepot.id] = sidepot;
            })
        });

        this.rodeo.exhibitions.forEach((exhibition) => {
            this.exhibitionMap[exhibition.id] = exhibition;
        })

        EntryCostGenerator.instance().reloadEntryInfo(this.rodeo, this.searchName);


        this.updateRodeoEvent();
        this.documentTitle = this.rodeo.name + " - " + 'Alpha';
        this.dataLoaded = true;
    }

    updateOptions() {
        this.showContactInfo = this.options.some(x => x == 'showContactInfo');
        this.showMembershipStatus = this.options.some(x => x == 'showMembershipStatus');

        console.log("this.options: ", this.options);
        console.log("this.showContactInfo: ", this.showContactInfo);
        console.log("this.showMembershipStatus: ", this.showMembershipStatus);
    }

    getExhibitionName(id: number) {
        return this.rodeo.exhibitions.filter(x => x.id == id)[0].name;
    }
    
    updateRodeoEvent() {
        EntryCostGenerator.instance().getCombinedRegistrations().forEach((contestantRegObject) => {
            contestantRegObject.hasSelectedRodeoEvent = false;

            contestantRegObject.registrations.forEach((registration) => {
                registration.hasSelectedRodeoEvent = false;

                if (this.selectedRodeoEvent == 'All' || registration.rodeoEventId == this.selectedRodeoEvent.id) {
                    contestantRegObject.hasSelectedRodeoEvent = true;
                    registration.hasSelectedRodeoEvent = true;
                }

                let contestantOneId = registration.teammateHeader ? registration.contestantTwoId : registration.contestantOneId;
                let contestantTwoId = registration.teammateHeader ? registration.contestantOneId : registration.contestantTwoId;
                let horseOneId = registration.teammateHeader ? registration.horseTwoId : registration.horseOneId;
                let horseTwoId = registration.teammateHeader ? registration.horseOneId : registration.horseTwoId;
    
                let allRuns = this.rodeo.rodeoEvents.filter(x => x.id == registration.rodeoEventId).flatMap(x => x.schedules).flatMap(x => x.runs).filter(x => 
                    x.contestantOneId == contestantOneId
                    && (!registration.horseOneId || horseOneId == x.horseOneId)
                    && (!contestantTwoId || contestantTwoId == x.contestantTwoId)
                    && (!registration.horseTwoId || horseTwoId == x.horseTwoId));
        
                let runs = allRuns.filter(x => x.round == 1);
                let maxRuns = 1;
                
                if (this.selectedRodeoEvent.ropingFormat == 'Draw')
                    maxRuns = this.selectedRodeoEvent.drawAmount;
                else if (this.selectedRodeoEvent.ropingFormat == 'PickAndDraw') {
                    maxRuns += this.selectedRodeoEvent.drawAmount;
                }
        
                let run = runs.filter(x => !x.used)[0];
                if (run && run != null) {
                    registration.run = new RodeoEventRun();
                    (registration as any).runCount = allRuns.filter(x => x.runIdentifier == run.runIdentifier && x.done).length;
                    Object.assign(registration.run, run);
                }
            });
        });
    }

    async downloadCsv() {
        try {
            var data = await this.reportService.getFullEntryReport(this.rodeo.id, this.options, this.searchName, this.selectedRodeoEvent == null ? this.selectedRodeoEvent : this.selectedRodeoEvent.id);

            const blob = new Blob([data as any], { type: "json" })
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.download = this.rodeo.name + "-Alpha-Sheet.csv";
            anchor.href = url;
            anchor.click();
        } catch (error) {
            console.log("Error downloading CSV");
        }
    }

    onNameSearchChange(searchValue) {
        if (!this.searchChangeObservable) {
            Observable.create(observer => {
                this.searchChangeObservable = observer;
            }).debounceTime(700)
                .distinctUntilChanged()
                .subscribe((text) => {
                    this.load();
                });
        }

        this.searchChangeObservable.next(searchValue);
    }

    matchRodeoEvents(a, b) {
        return a.id == b.id;
    }

    getBackNumber(rodeoEvent: RodeoEvent, account: Account, horse: Horse) {
        if (!rodeoEvent)
            return;

        let matchingBackNumbers = null;

        if (this.rodeo.backNumbers && this.rodeo.backNumbers.length > 0) {
            matchingBackNumbers = this.rodeo.backNumbers.filter(x => x.eventType == rodeoEvent.eventType);

            if (matchingBackNumbers.length == 0)
                matchingBackNumbers = this.rodeo.backNumbers.filter(x => !x.eventType);
        }

        var backNumber = null;
        if (matchingBackNumbers != null) {
            if (this.rodeo.backNumberConfigs[0].byHorse) {
                if (horse) {
                    backNumber = matchingBackNumbers.filter(x => x.horseId == horse.id)[0];
                }
            } else if (account)  {
                backNumber = matchingBackNumbers.filter(x => x.accountId == account.id)[0];
            }
        }

        if (backNumber != null)
            return '(' + backNumber.number + ')';
        else
            return '';
    }

    ionViewDidEnter() {
        setTimeout(() => {
            window.document.title = this.documentTitle;
            window.print();
            this.nav.pop();
        }, 0);
    }

    print() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        this.nav.push(AlphaReport, {
            rodeo: this.rodeo,
            printing: true,
            showContactInfo: this.options,
            searchName: this.searchName,
            selectedRodeoEvent: this.selectedRodeoEvent
        }).then(() => { this.popoverActive = false; });
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/reports/report-alpha.ts